import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Image } from 'components/Image';
import { Spinner } from 'components/Spinner';
import { toFormattedDate } from 'components/DateTime';
import './ExternalAvailabilityGrid.scss';
/**
 * @component ExternalAvailabilityGrid
 * @since 1.0.0
 * Categories as rows, days as columns. Availability is carried by the
 * count's colour only (no filled cells).
 */
export function ExternalAvailabilityGrid(props) {
    const { logo, title, loading, loadingMessage, emptyMessage, categories, timeUnits } = props;
    const className = classNames('external-availability-grid', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "external-availability-grid-header" },
            React.createElement("div", { className: "external-availability-grid-logo" },
                React.createElement(Image, { cover: true, source: logo })),
            React.createElement("span", { className: "external-availability-grid-title" }, title)),
        loading && (React.createElement("div", { className: "external-availability-grid-message" },
            React.createElement(Spinner, { style: "small" }),
            React.createElement("span", null, loadingMessage))),
        !loading && categories.length === 0 && (React.createElement("div", { className: "external-availability-grid-message" },
            React.createElement("span", null, emptyMessage))),
        !loading && categories.length > 0 && (React.createElement("div", { className: "external-availability-grid-scroll" },
            React.createElement("table", { className: "external-availability-grid-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "external-availability-grid-category" }),
                        timeUnits.map((unit) => (React.createElement("th", { key: unit, className: "external-availability-grid-day" },
                            React.createElement("span", { className: "external-availability-grid-weekday" }, toFormattedDate(unit, {
                                w: 'short',
                                d: undefined,
                                m: undefined,
                                y: undefined
                            })),
                            React.createElement("span", { className: "external-availability-grid-date" }, toFormattedDate(unit, { m: 'short', y: undefined }))))))),
                React.createElement("tbody", null, categories.map((cat) => {
                    var _a;
                    return (React.createElement("tr", { key: cat.categoryId },
                        React.createElement("th", { className: "external-availability-grid-category" }, (_a = cat.categoryName) !== null && _a !== void 0 ? _a : cat.categoryId),
                        timeUnits.map((unit, i) => {
                            var _a;
                            const count = (_a = cat.availabilities[i]) !== null && _a !== void 0 ? _a : 0;
                            return (React.createElement("td", { key: unit, className: classNames('external-availability-grid-count', count === 0 ? 'is-unavailable' : 'is-available') }, count));
                        })));
                })),
                categories.length > 1 && (React.createElement("tfoot", null,
                    React.createElement("tr", { className: "external-availability-grid-total" },
                        React.createElement("th", { className: "external-availability-grid-category" }, t('Total')),
                        timeUnits.map((unit, i) => {
                            const total = categories.reduce((sum, cat) => { var _a; return sum + ((_a = cat.availabilities[i]) !== null && _a !== void 0 ? _a : 0); }, 0);
                            return (React.createElement("td", { key: unit, className: classNames('external-availability-grid-count', total === 0 ? 'is-unavailable' : 'is-available') }, total));
                        })))))))));
}
